import {apiRequest} from "./client";

export async function submitContact(data: {nume: string; email: string; telefon: string; mesaj: string}): Promise<{ok: boolean; message: string}> {
  return apiRequest<{ok: boolean; message: string}>("/contact", {method: "POST", body: data});
}

export async function submitSpecialOrder(data: {nume: string; email: string; telefon: string; produs: string; cod: string; mesaj?: string}): Promise<{ok: boolean; message: string}> {
  return apiRequest<{ok: boolean; message: string}>("/contact/special-order", {method: "POST", body: data});
}

export async function submitLead(data: Record<string, string>): Promise<{ok: boolean}> {
  return apiRequest<{ok: boolean}>("/leads", {method: "POST", body: data});
}
